<template>
  <div>
    <el-input :style="{width:width + 'px'}" size="small" v-if="edit" v-model="openCardDialog" placeholder="请输入内容"></el-input>
    <span v-else>{{input}}</span>
  </div>
</template>

<script>
export default {
  name: "pageInput",
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    input: {
      type: [String,Number],
    },
    width: {
      type: [String,Number],
      default: 200
    }
  },
  data() {
    return {
    }
  },
  computed: {
    openCardDialog: {
      get() {
        return this.input
      },
      set(val) {
        this.$emit('update:input', val)
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pageConfig/pageInput.vue